module.exports = __webpack_public_path__ + "img/AF_Tool_Figure_FR.8c129110.png";